/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { DeleteImageErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const deleteEncountersImages = (encounterId: number, imageId: number) => {
  return api<void>({ url: `/api/encounters/${encounterId}/images/${imageId}`, method: 'DELETE' });
};

export const getDeleteEncountersImagesMutationOptions = <
  TError = DeleteImageErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEncountersImages>>,
    TError,
    { encounterId: number; imageId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEncountersImages>>,
  TError,
  { encounterId: number; imageId: number },
  TContext
> => {
  const mutationKey = ['deleteEncountersImages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEncountersImages>>,
    { encounterId: number; imageId: number }
  > = (props) => {
    const { encounterId, imageId } = props ?? {};

    return deleteEncountersImages(encounterId, imageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEncountersImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEncountersImages>>
>;

export type DeleteEncountersImagesMutationError = DeleteImageErrorResponse;

export const useDeleteEncountersImages = <TError = DeleteImageErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEncountersImages>>,
      TError,
      { encounterId: number; imageId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEncountersImages>>,
  TError,
  { encounterId: number; imageId: number },
  TContext
> => {
  const mutationOptions = getDeleteEncountersImagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
